import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import FileSaver from 'file-saver'
import { push } from 'react-router-redux'

import { actionSet } from './utils'
import { hideSpinner, showSpinner } from './spinner'
import { renderToastWarn } from 'utils/ToastUtils'

import {
  UPDATE_MENU_MISSION_REQUEST,
  UPDATE_MENU_MISSION_SUCCESS,
  UPDATE_MENU_MISSION_ERROR,
  GET_MENU_MISSION_FROM_LIST,
  RESET_MENU_MISSIONS,
  RESET_EDIT_MENU_MISSION,
  REMOVE_MENU_MISSION_SUCCESS,
  REMOVE_MENU_MISSION_ERROR,
  GET_PAGES,
  FETCH_MENU_MISSIONS_REQUEST_V2,
  FETCH_MENU_MISSIONS_ERROR_V2,
  FETCH_MENU_MISSIONS_SUCCESS_V2,
  SAVE_MENU_MISSIONS_REQUEST_V2,
  SAVE_MENU_MISSIONS_SUCCESS_V2,
  SAVE_MENU_MISSIONS_ERROR_V2,
  UPDATE_MENU_MISSIONS_REQUEST_V2,
  UPDATE_MENU_MISSIONS_SUCCESS_V2,
  UPDATE_MENU_MISSIONS_ERROR_V2,
  MENU_MISSION_REMOVE_REQUEST_V2,
  MENU_MISSION_REMOVE_SUCCESS_V2,
  MENU_MISSION_REMOVE_ERROR_V2,
  MENU_MISSION_UPDATE_PERMISSIONS_REQUEST,
  MENU_MISSION_UPDATE_PERMISSIONS_SUCCESS,
  MENU_MISSION_UPDATE_PERMISSIONS_ERROR,
  ALL_PROFILES,
} from 'actionTypes'

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const buildPagesAction = (metadata = {}, fallback = {}) => ({
  type: GET_PAGES,
  pages: metadata.pageCount != null ? metadata.pageCount : fallback.pages || 1,
  current: metadata.page != null ? metadata.page : fallback.current || 1,
  count: metadata.totalCount != null ? metadata.totalCount : fallback.count || 0,
})

/*
 * SAVE or UPDATE MENU_MISSION
 */
export const update =
  (token, toSave, toRemove = null) =>
  (dispatch) => {
    dispatch(updateMissionRequest())

    let fields = {
      toSave: {
        ...toSave,
      },
    }

    if (toRemove) {
      fields = {
        toSave: {
          ...toSave,
        },
        toRemove: {
          ...toRemove,
        },
      }
    }

    return new Api(token, dispatch)
      .post(API_URL.MENU_MISSION_SAVE, fields)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateMissionSuccess(response.data))
        dispatch(hideSpinner())
        dispatch(fetch(token))
      })
      .catch((error) => {
        dispatch(updateMissionError(error))
        dispatch(hideSpinner())
      })
  }

export const updateMissionRequest = () => ({
  type: UPDATE_MENU_MISSION_REQUEST,
})

export const updateMissionSuccess = (data) => ({
  type: UPDATE_MENU_MISSION_SUCCESS,
  payload: data,
})

export const updateMissionError = (error) => ({
  type: UPDATE_MENU_MISSION_ERROR,
  payload: error,
})

/*
 * GET MENU_MISSION FROM LIST
 */
export const getMenuMission = (index) => (dispatch) => {
  dispatch({
    type: GET_MENU_MISSION_FROM_LIST,
    index,
  })

  dispatch(push(`/missions/${index}`))
}

/*
 * REMOVE MENU_MISSION
 */
export const remove = (token, lsMissionMenus) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.MENU_MISSION_REMOVE, lsMissionMenus)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(hideSpinner())
      dispatch(removeMissionSuccess())
      dispatch(fetch(token))
    })
    .catch((error) => {
      dispatch(removeMissionError(error))
      dispatch(hideSpinner())
    })

export const removeMissionSuccess = () => ({
  type: REMOVE_MENU_MISSION_SUCCESS,
})

export const removeMissionError = (error) => ({
  type: REMOVE_MENU_MISSION_ERROR,
  payload: error,
})

export const resetMenuMissions = () => ({
  type: RESET_MENU_MISSIONS,
})

export const resetEditMenuMissions = () => ({
  type: RESET_EDIT_MENU_MISSION,
})

/**
 * New actions
 */
export const fetch =
  (token, param = DEFAULT_PAGINATION) =>
  async (dispatch) => {
    try {
      dispatch(showSpinner())

      dispatch(actionSet(FETCH_MENU_MISSIONS_REQUEST_V2))

      const response = await new Api(token, dispatch).get(
        API_URL.FETCH_MENU_MISSIONS_V2,
        param
      )

      const responseAll = await new Api(token, dispatch).get(
        API_URL.FETCH_MENU_MISSIONS_V2,
        {
          ...param,
          genericSearch: '',
          isMission: true,
          isPersonalProfile: true,
          lsCdMenus: [],
          hasPagination: false,
        }
      )

      dispatch(actionSet(ALL_PROFILES, responseAll.data))

      dispatch(actionSet(FETCH_MENU_MISSIONS_SUCCESS_V2, response.data))

      return dispatch(
        buildPagesAction(response.metadata, {
          current: param.page,
          count: (response.data || []).length,
          pages: 1,
        })
      )
    } catch (error) {
      return dispatch(actionSet(FETCH_MENU_MISSIONS_ERROR_V2, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const save =
  (token, param, successCallback, errorCallback) => async (dispatch) => {
    try {
      dispatch(showSpinner())

      dispatch(actionSet(SAVE_MENU_MISSIONS_REQUEST_V2))

      const response = await new Api(token, dispatch).post(
        API_URL.SAVE_MENU_MISSIONS_V2,
        param
      )

      if (response) {
        const status = response.cdStatus

        if (status === 200) {
          dispatch(actionSet(SAVE_MENU_MISSIONS_SUCCESS_V2))

          return successCallback()
        }
        if (status === 422) {
          const { data } = response

          if (data) {
            errorCallback(data)
          }
        }
      }

      return dispatch(actionSet(SAVE_MENU_MISSIONS_ERROR_V2))
    } catch (error) {
      dispatch(actionSet(SAVE_MENU_MISSIONS_ERROR_V2, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const updateProfile =
  (token, param, successCallback) => async (dispatch) => {
    try {
      dispatch(showSpinner())

      dispatch(actionSet(UPDATE_MENU_MISSIONS_REQUEST_V2))

      await new Api(token, dispatch).put(API_URL.UPDATE_MENU_MISSIONS, param)

      dispatch(actionSet(UPDATE_MENU_MISSIONS_SUCCESS_V2))

      return successCallback()
    } catch (error) {
      dispatch(actionSet(UPDATE_MENU_MISSIONS_ERROR_V2, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const deleteProfile =
  (token, param, successCallback) => async (dispatch) => {
    try {
      dispatch(showSpinner())

      dispatch(actionSet(MENU_MISSION_REMOVE_REQUEST_V2))

      await new Api(token, dispatch).post(API_URL.MENU_MISSION_REMOVE, param)

      dispatch(actionSet(MENU_MISSION_REMOVE_SUCCESS_V2))

      return successCallback()
    } catch (error) {
      dispatch(actionSet(MENU_MISSION_REMOVE_ERROR_V2, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const exportCsv =
  (token, filters, t) => async (dispatch) => {
    try {
      dispatch(showSpinner())

      const param = {
        ...filters,
        hasPagination: false,
      }

      const response = await new Api(token, dispatch).post(
        API_URL.MENU_MISSION_REPORT_CSV,
        param
      )

      const csvData = response && response.data ? response.data : ''
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' })
      FileSaver.saveAs(blob, 'gestao-acessos.csv')
    } catch (error) {
      if (t) renderToastWarn(t('report.generation.error'))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const updatePermissions =
  (token, param, successCallback) => async (dispatch) => {
    try {
      dispatch(showSpinner())

      dispatch(actionSet(MENU_MISSION_UPDATE_PERMISSIONS_REQUEST))

      await new Api(token, dispatch).put(
        API_URL.UPDATE_MENU_MISSIONS_PERMISSIONS,
        param
      )

      dispatch(actionSet(MENU_MISSION_UPDATE_PERMISSIONS_SUCCESS))

      return successCallback()
    } catch (error) {
      dispatch(actionSet(MENU_MISSION_UPDATE_PERMISSIONS_ERROR, error))
    } finally {
      dispatch(hideSpinner())
    }
  }
